<template>
  <div id="sofia-file-uploader" class="mt-3 mt-xl-0">
    <div class="sofia-uploader">
      <div
        id="drag-drop-container"
        @dragover="drag_over"
        @dragleave="drag_leave"
        @drop="drop"
      >
        <div
          id="sofia-file-uploader-container"
          class="rounded justify-content-center d-flex flex-row"
          :class="sofia_file_uploader_container_class"
          >
          <div class="title__sofia">
            <img :src="get_img_url('sofia-color.png')"/>
            <h4 v-html="t('sofia.sofia_uploader.sofia_title')" class="mb-0"/>
          </div>
          <span v-if="error" class="file-error">
            {{ t("sofia.sofia_uploader.format_error") }}
          </span>
          <span v-if="error_upload" class="file-error">
            {{ t("sofia.sofia_uploader.error_uploading") }}
          </span>
          <div v-if="uploading_file" class="row w-100 ">
            <div class="col-md-4 text-center m-auto ">
              <span class="loader-general fileUp" style="z-index: 100;"></span>
            </div>
            <div class="col-md-8 justify-content-center d-flex flex-column">
              <div
                class="row selected_file "
                v-if="is_selected_file"
                :key="selected_file.name"
                >
                <span class="file_name text-center w-100">
                  {{ selected_file.name }}
                </span>
              </div>
              <button id="cancel-btn" type="button" v-if="!time_out_request && !error" class="btn btn-link p-0 mt-1"  @click="cancel()">
                {{ t("components.sofia_file_analyzer.cancel") }}
              </button>
              <span v-else class="text-primary text-center mt-1" disabled>
                {{ t("components.sofia_file_analyzer.redirecting") }}
              </span>
            </div>
          </div>
          <div class="cluster__Sofia ml-2" v-else>
            <input
              type="file"
              id="assetsFieldHandle"
              class="d-none"
              @change="onChange"
              ref="file"
              accept=".pdf,.txt,.rtf,.doc,.docx,.odt,.html,.ott,.sxw"
            />
            <label
              for="assetsFieldHandle"
              id="file-selector-text"
              class="mr-5"
              :class="file_selector_text_class"
            >
              <i class="fas fa-cloud-upload-alt mr-1" />
              <span id="drag" v-html="t('sofia.sofia_uploader.release_file')" />
              <span>
                {{ t("or") }}
              </span>
              <span id="select" class="cursor-pointer">
                {{ sofia_uploader_translations('from_pc') }}
              </span>
            </label>
            <button class="btn btn-outline-info btn-sm ml-1" @click="new_document()">
              <i class="fas fa-plus mr-1"></i>
              <p class="m-0 text-left">{{ sofia_uploader_translations('blank_document') }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "common/mixins.js";
import SofiaUploaderMixin from "common/mixins/uploader_mixin";

export default {
  name: "sofia-file-uploader-vue",
  mixins: [mixins.requests, mixins.translate, SofiaUploaderMixin],
  props: {
    manage_redirect: { type: Boolean, default: true },
  },
  data() {
    return {
      redirect: this.manage_redirect,
      appname: gon.current_app
    }
  },
  computed: {
    sofia_file_uploader_container_class() {
      let selected_file_class = this.is_selected_file ? "selected-file" : ""

      return this.dragged_status_class + selected_file_class
    },
    file_selector_text_class() {
      return this.is_selected_file ? "d-none" : ""
    }
  },
  methods: {
    get_img_url(img_name) {
      return require('../../../assets/images/sofia/'+ img_name )
    },
    sofia_uploader_translations(key) {
      return I18n.t(`sofia.sofia_uploader.${this.appname}.${key}`)
    }
  }
}
</script>
